import React from 'react';
import { NavLink } from 'react-router-dom';
import './css/NavBox.css';

const navItems = [
    { id: 1, label: 'Группийн танилцуулга', path: 'about/introduction' },
    { id: 2, label: 'Үнэт зүйлс, баримтлах зарчим', path: 'about/values' },
    { id: 3, label: 'Бидний түүх', path: 'about/history' },
    { id: 4, label: 'Удирдлага', path: 'about/leadership' },
    { id: 5, label: 'Хувьцаа эзэмшигчид', path: 'about/shareholders' },
    { id: 6, label: 'Ёс зүйн дүрэм', path: 'about/ethics' },
];

const NavBox: React.FC = () => {


    return (
        <div className="nav-box">
            {navItems.map((item) => (
                <NavLink
                    key={item.id}
                    to={`/${item.path}`}
                    className={({ isActive }) =>
                        `nav-item ${isActive ? 'nav-item--active' : ''}`
                    }
                >
                    <span>{item.label}</span>
                    <span className="nav-icon">⮕</span>
                </NavLink>
            ))}
        </div>
    );
};

export default NavBox;